import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { useAuth0 } from "../../react-auth0-spa";
import { isAuthenticationExcludedUrl } from "../../util/authenticationExcludeUrls";
import { currentReturnPath } from "../../util/safeReturnPath";

const PrivateRoute = ({ component: Component, path, ...rest }) => {
  const { loading, isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (loading || isAuthenticated) {
      return;
    }
    const fn = async () => {
      await loginWithRedirect({
        // Come back to the page that was opened (a shared report link), not to the route pattern.
        appState: { targetUrl: currentReturnPath() }
      });
    };
    fn();
  }, [loading, isAuthenticated, loginWithRedirect, path]);

  const render = props =>
    isAuthenticated === true || isAuthenticationExcludedUrl() ? <Component {...props} /> : null;

  return <Route path={path} render={render} {...rest} />;
};

export default PrivateRoute;
